import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        title: 'My Account',
        welcomeHeading: 'A BMS Service account allows you to:',
        reasonDistance: 'Check the state of your batteries from anywhere',
        reasonAlerts: 'Be notified if ever one of your batteries needs your attention',
        reasonHistory: 'Check the history of your batteries',
        connectButton: 'Connect to the BMS Service',
        disconnectButton: 'Disconnect',

        nameLabel: 'Name: ',
        emailLabel: 'Email: ',
    },
    fr:{
        title: 'Mon compte',
        welcomeHeading: 'Une compte du Service BMS vous permet :',
        reasonDistance: 'De vérifier l\'état de vos batteries de n\'importe où',
        reasonAlerts: 'D\'être notifié si jamais un de vos batteries a besoin de votre attention',
        reasonHistory: 'De consulter l\'historique de vos batteries',
        connectButton: 'Me connecter au Service BMS',
        disconnectButton: 'Déconnecter',

        nameLabel: 'Nom: ',
        emailLabel: 'Email: ',
    }
})

export default strings